import * as React from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import WelcomeContainer from './containers/welcome'
import ContactsContainer from './containers/contacts'

class App extends React.Component {
	render() {
		return (
			<Router>
				<Switch>
					<Route exact={true} path="/" component={WelcomeContainer}/>
					<Route exact={true} path="/contacts" component={ContactsContainer}/>
				</Switch>
			</Router>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx